<script lang="ts" context="module">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getJoodMembershipType, getPriceHTMLOrFree, getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import { getJoodCardImageUrlNew } from '../services/pdp-data-services';
  import UpgradeService from './UpgradeService.svelte';
  const userJoodLevel = getJoodMembershipType();
  const { joodFullCappingLimitReached } = getAppConfig();
  const visible = true;
</script>

<script lang="ts">
  export let data;
  export let active: boolean;
  export let addonView: boolean;
  export let readonly = false;
  export let joodServiceCard = null;
  export let hideNameField = false;
  export let serviceJoodCardType;
  const { productDetails, pageTemplate } = getAppConfig();

  const joodUserType = joodServiceCard ? joodServiceCard : userJoodLevel;
  const isUpgrade = pageTemplate === 'extraPreOrderLandingPageTemplate' && productDetails?.upgradeDisclaimerText;
  $: isNoPlan = data?.noPlanOption;
  $: savings = getSavings(data);
  $: oldPrice = data?.servicePrice?.value;
  $: displayPrice = oldPrice - savings;
  const isJoodMember = joodUserType !== 'NOPRIME';
  const joodCardImageUrl = getJoodCardImageUrlNew(userJoodLevel, true, 24);

  function getSavings(data) {
    if (joodFullCappingLimitReached === 'true') {
      return 0;
    }

    switch (userJoodLevel) {
      case 'NOPRIME':
        return data?.discountedPrice?.value || 0;
      case 'BASICPRIME':
        return data?.basicPrimeDiscountPrice?.value || data?.discountedPrice?.value || 0;
      case 'VIPPRIME':
        return data?.vipPrimeDiscountPrice?.value || data?.discountedPrice?.value || 0;
      case 'SMARTPRIME':
        return data?.smartPrimeDiscountPrice?.value || data?.discountedPrice?.value || 0;
    }
  }
  function getLabelHtml(vasType) {
    if (!vasType?.label) {
      vasType.label = '';
    }
    if (addonView) return getStr('extra.pdp.service.addon');
    else return ` <strong>${vasType?.label}</strong>`;
  }
  function getName(vasType) {
    if (addonView) return `${getStr('extra.pdp.service.accidental.warranty.text')} (${vasType?.name})`;
    else if (joodUserType === 'NOPRIME') return vasType?.name;
    else if (joodUserType === 'BASICPRIME') return getStr('extra.pdp.prime.blue.display.text');
    else if (joodUserType === 'SMARTPRIME') return getStr('extra.pdp.prime.smart.display.text');
    return getStr('extra.pdp.prime.gold.display.text');
  }
</script>

<!-- Safeguard tile view -->
{#if visible}
  <div class="position-relative discount-service" class:c_serviceupgrade={isUpgrade}>
    <UpgradeService />
    <button
      class="c_vas-price-tile vas-price-tile safeguard-tile user-{joodUserType} service-{serviceJoodCardType} {serviceJoodCardType
        ? 'user-service-card'
        : ''}"
      class:active
      class:addonView
      class:readonly
      disabled={readonly}
      on:click
      class:no-plan-tile={isNoPlan}
    >
      {#if isNoPlan}
        <section class="name">{data?.vasType?.name}</section>
      {:else}
        <section class="label">
          {@html getLabelHtml(data?.vasType)}
          {#if !hideNameField && pageTemplate === 'extraPreOrderLandingPageTemplate'}
            ({getName(data?.vasType)})
          {/if}
        </section>

        {#if !hideNameField && pageTemplate !== 'extraPreOrderLandingPageTemplate'}
          <section class="name" class:jood-member={isJoodMember}>
            {getName(data?.vasType)}
          </section>
        {/if}
        <section class="price" class:mt-8={hideNameField}>
          {#if savings > 0}
            <section class="savings">
              {@html getPriceHTMLOrFree(savings)}
            </section>
            <span class="striked-off">{oldPrice}</span>
          {:else}
            <div>
              {@html getPriceHTMLOrFree(displayPrice)}
            </div>
          {/if}
          {#if joodCardImageUrl}
            <img src={joodCardImageUrl} alt="Jood Card" />
          {/if}
        </section>
      {/if}
      {#if active}
        <section class="active-icon">
          <Icon glyph="check" type="font" desktopSize={24} />
        </section>
      {/if}
    </button>
  </div>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .discount-service {
    flex-grow: 1;
  }
  .vas-price-tile {
    position: relative;
    text-align: start;
    background-color: $primary-white;
    padding: 8px 8px 14px;
    border: 1px solid $secondary-gray-02;
    border-radius: 8px;
    color: $neutral-dark-01;
    width: 110px;
    height: 82px;
    flex-grow: 1;
    @include desktop-max-width {
      width: 94px;
    }

    &.user-service-card {
      color: $neutral-dark-01;
      width: 100%;
      min-width: max-content;
    }
    &.addonView {
      flex-grow: 0;
      flex-basis: 50%;
    }
    &.no-plan-tile {
      display: flex;
      align-items: center;
      justify-content: center;

      .name {
        margin: 0;
      }
    }
    &.readonly {
      cursor: default;
    }

    .label {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $neutral-dark-03;

      strong {
        font-size: 11px;
      }
    }
    .name {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      margin-block: 2px 8px;
    }
    .price {
      font-size: 16px;
      line-height: 18px;
      font-weight: 400;
      display: flex;
      align-items: flex-start;
      gap: 4px;
      flex-direction: column;
      .striked-off {
        color: $neutral-dark-03;
        font-weight: 400;
        font-size: 11px;
        line-height: 14px;
        text-decoration: line-through;
      }
      img {
        border-radius: 2px;
      }

      &.mt-8 {
        margin-top: 8px;
      }
    }

    .savings {
      .striked-off {
        color: $neutral-dark-03;
        font-weight: 400;
        font-size: 11px;
        line-height: 14px;
        text-decoration: line-through;
      }
      .orange-text {
        color: $functional-orange;
        font-size: 12px;
        line-height: 14px;
      }
    }

    &.user-VIPPRIME,
    &.user-SMARTPRIME,
    &.user-BASICPRIME {
      // border-color: transparent;
      border: 1px solid $secondary-gray-02;

      &:not(.addonView) .name {
        margin-block: 8px 2px;
        font-size: 11px;
        line-height: 12px;
      }
    }
  }
</style>
